<template>
    <div id="deliverydate">
        <a-modal :title="$t('pubGicSet.ShipOutDate')" v-model="visible" @ok="handleOk">
            <template slot="footer">
                <a-button type="primary" small="size" @click="saveDeliveryDate">{{ $t('publicLang.Save') }}</a-button>
            </template>
            <a-form :form="form">
                <a-form-item :label="$t('pubGicSet.ShipOutDate')"  v-bind="formItemLayout">
                    <a-date-picker  v-decorator="['deliverydate', { rules: [{ required: true, message: $t('publicLang.Required') }]}]" />
                </a-form-item>
            </a-form>
        </a-modal>
    </div>
</template>
<script>
    import ajax from "../../../api/ajax";
    import api from "../../../api/url";
    export default{
        data(){
            return{
                visible: false,
                form:  this.$form.createForm(this),
                delData: {},
                formItemLayout: {
                    labelCol: {
                        xs: { span: 24 },
                        sm: { span: 8 }
                    },
                    wrapperCol: {
                        xs: { span: 24 },
                        sm: { span: 16 }
                    }
                },
            }
        },
        methods:{
            handleOk(){
                this.visible = false
            },
            show(tt){
                this.visible = true
                this.delData = tt
            },
            saveDeliveryDate(){
                this.form.validateFields((err,val)=>{
                    if(!err){
                        let deliverydate = (val.deliverydate).format('YYYY-MM-DD')
                        this.delData.params.push({key: 'deliveryDate',value: deliverydate})
                        ajax.post(api.SOEXTENDERCONFORM,this.delData).then(res=>{
                            if(res.code == 200){
                                this.visible = false;
                                if(this.delData!=undefined && this.delData.params !=undefined) {
                                    let uidList = this.delData.params
                                        .filter(param => param.key === "uid")  // 筛选出 key 为 "uid" 的参数 Filter out parameters with the key "uid".
                                        .map(param => param.value);           // 提取 value 值 Extract the value(s)
                                    if(uidList != undefined && uidList != null && uidList.length > 0) {
                                        let topMenu = JSON.parse(sessionStorage.getItem("menu"))
                                        let topMenuActive = sessionStorage.getItem("menuActive")
                                        for(let i in topMenu){
                                            if(topMenu[i].key == topMenuActive){
                                                let idStr =uidList.join(',');
                                                let array =  idStr.split(",")
                                                if (array.length <= 100) {
                                                    //    return true;  // 长度小于100，符合条件
                                                    topMenu[i].importUids = idStr;
                                                }
                                            }
                                        }
                                        sessionStorage.setItem("menu", JSON.stringify(topMenu));
                                    }

                                }


                                this.$emit('deliverdate','init')
                            }else{
                                this.$customMessage.error(res.msg);
                            }
                        })
                    }
                })
            }
        }
    }
</script>